import React from 'react'
import { Box, Flex, Heading } from 'rebass/styled-components'
import ImageRender from '../general/ImageRender'

const NoResults = () => (
    <Box variant='container' pt='xs'>
        <Flex flexDirection={['column', 'column', 'column', 'column', 'row']} justifyContent='space-between' alignItems={['flex-start', 'flex-start', 'flex-start', 'flex-start', 'flex-end']}>
            <Heading as='h2' variant='h1'>No Results</Heading>
            <Heading as='h2' variant='h2' sx={{
                textTransform: 'uppercase',
            }}>Have Another Go</Heading>
        </Flex>
        <ImageRender file={{
            filepath: `https://res.cloudinary.com/kidston/image/upload/website/no-results.jpg`,
            type: 'static',
            media_type: 'image',
        }} />
    </Box>
)
export default NoResults
